import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { AgencyModel } from '@models/types'

interface AgencyProps {
  callbacks?: {
    onClick: () => void,
  },
  entity: AgencyModel,
  selected: boolean,
}

const Agency = (props: AgencyProps) => {
  const {
    callbacks,
    entity: { id, title },
    selected,
  } = props

  const { onClick } = callbacks || {}

  return (
    <DashboardModuleListItem
      isChecked={selected}
      onClick={onClick}
      showCheckbox
      title={title}
    >
      <Text color="bodyFontLightColor">ID #{id}</Text>
    </DashboardModuleListItem>
  )
}

export default Agency
